import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppErrorComponent, NotFoundComponent } from 'app/app-layout/components';
import { AppRoute } from 'app/app-layout/constants/app-route.enum';
import { AppComponent } from 'app/app.component';
import { LoginComponent } from 'app/login/components/login/login.component';
import { SSOLandingPageLoginComponent } from 'app/sso-landing-page/components/login/login.component';
import { SSOLandingPageErrorComponent } from 'app/sso-landing-page/components/error/error.component';
import { LogoutComponent } from 'app/login/components/logout/logout.component';

import { PasswordResetComponent } from './login/components/password-reset/password-reset.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: LoginComponent },
  { path: 'sso/welcome', pathMatch: 'full', component: SSOLandingPageLoginComponent },
  { path: 'sso/error', pathMatch: 'full', component: SSOLandingPageErrorComponent },
  { path: AppRoute.login, component: LoginComponent },
  { path: AppRoute.logout, component: LogoutComponent },
  { path: AppRoute.forgotPassword, component: PasswordResetComponent },
  { path: AppRoute.error, component: AppErrorComponent },
  { path: '**', component: NotFoundComponent },
];

export const routedComponents: any[] = [AppComponent];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
